import { render } from "./MshelGroup.vue?vue&type=template&id=7e0a754c&scoped=true"
import script from "./MshelGroup.vue?vue&type=script&lang=js"
export * from "./MshelGroup.vue?vue&type=script&lang=js"

import "./MshelGroup.vue?vue&type=style&index=0&id=7e0a754c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0a754c"]])

export default __exports__